export default __webpack_public_path__ + "static/media/edit.4e5aa863.svg";